import React from "react";
import "./ProductDetails.css"; // Ümumi stil faylı

function BirdDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    const getStatus = (val) => val === true ? "Bəli" : val === false ? "Xeyr" : "Bilinmir";

    return (
        <div className="product-details">
            <h3 className="product-details-title">Quş Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Ad:</strong> {product.name || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Quş növü:</strong> {product.birdType || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Yaş:</strong> {product.age ? `${product.age} yaş` : "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cins:</strong> {product.gender || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Sağlamlıq durumu:</strong> {product.healthStatus || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Vəziyyət:</strong> {product.condition || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Qəfəs daxildir:</strong> {getStatus(product.includesCage)}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default BirdDetails;
